import React from 'react';

import { Heading, Reports } from '../../../components';



const ReportSection = () => {
  return (

    <section>

      {/* Section heading */}
      <Heading title={'our reports'} subTitle={'Explore Our Fire Reports'} />

      {/* Reports Section */}
      <Reports />

    </section>

  );
}

export default ReportSection;